/**
 * Human labels for the three staff roles, one place, since the sidebar's role chip is the first
 * screen that has ever needed to say one out loud rather than branch on it.
 */
import type { StaffRole } from '@apuestapr/contracts';

export const staffRoleLabels: Readonly<Record<StaffRole, string>> = {
  admin: 'Administrador',
  manager: 'Gerente',
  agente: 'Agente',
};
